export const OPEN_DRAWER = 'containers/mainPanel/panelDrawer/OPEN_DRAWER'
export const CLEAR_DRAWER = 'containers/mainPanel/panelDrawer/CLEAR_DRAWER'
export const OPEN_INNER_DRAWER =
  'containers/mainPanel/panelDrawer/OPEN_INNER_DRAWER'
export const CLEAR_INNER_DRAWER =
  'containers/mainPanel/panelDrawer/CLEAR_INNER_DRAWER'
